import settings from 'gatsby-core-theme/src/constants/settings.mjs'
export default {
  ...settings,
  newsletter:{
    default: {
      filter_pages: [],
    }
  },

};
